<template>
  <div class="Partners" :style="cssProps">
    <div v-if="this.auto" class="Partners-Auto">
      <div class="Partners-Container">
        <div class="Partners-Circle" v-for="(partner, index) in this.itemsArray" :key="index">
          <img :class="{'Partners-Circle-bigger': partner.src === 'gip.png'}" :src="`/${type}/${partner.src}`" :alt="partner.alt"/>
        </div>
      </div>
    </div>
    <!-- <div v-else class="Partners-NoAuto">
        <div class="Partners-Container">
            <div class="Partners-Circle" v-for="(partner, index) in this.sortedArray.slice(this.i, this.max)" :key="index">
                <img :src="`/img/${partner.src}`" :alt="partner.alt" />
            </div>
        </div>
        <div class="Partners-Arrow">
            <div @click="slide(0)" class="Partners-Arrow-Circle">
                <img src="/img/global/left-arrow.svg" alt="Left Arrow" />
            </div>
            <div @click="slide(1)" class="Partners-Arrow-Circle">
                <img src="/img/global/right-arrow.svg" alt="Left Arrow" />
            </div>
        </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Partners",
  props: [
    'items',
    'limit',
    'auto',
    'type', // clients | partners
  ],
  data() {
    return {
      i: 0,
      max: this.limit,
      total: this.items.length,
      itemsArray: null,
      sortedArray: null,
      srcArray: {}
    }
  },
  mounted() {
    this.changeCss();
    this.sortedArray = this.sortArray(this.items);
    let temp = this.sortArray(this.items);
    this.itemsArray = temp.concat(temp);
  },
  methods: {
    slide(val) {
      if (val == 0) {
        if (this.i !== 0 && this.i > 0) {
          this.i--;
          this.max--;
        }
      } else {
        if (this.i !== (this.total - this.limit)) {
          this.i++;
          this.max++;
        }
      }
      this.changeCss();
    },
    changeCss() {
      const left = document.getElementsByClassName('Partners-Arrow-Circle')[0];
      const right = document.getElementsByClassName('Partners-Arrow-Circle')[1];
      if (left !== undefined && right !== undefined) {
        left.classList.remove('Circle-Active');
        right.classList.remove('Circle-Active');
        if (this.i == 0) {
          left.classList.add('Circle-Active');
        }
        if (this.i == (this.total - this.limit)) {
          right.classList.add('Circle-Active');
        }
      }
    },
    sortArray(array) {
      array.sort(function (a, b) {
        return a.src.localeCompare(b.src);
      });
      return array;
    }
  },
  computed: {
    cssProps() {
      return {
        '--nbr': this.total,
        '--nbr2': (this.total * 2)
      }
    }
  }
}
</script>

<style scoped>
/* 
* Global 
*/
.Partners-Container, .Partners-Arrow {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  padding: 30px;
}

.Partners-Arrow {
  padding: 0 80px;
}

.Partners-Container {
  padding-bottom: 50px;
}

.Partners-Auto {
  width: 75%;
  overflow: hidden;
  margin: auto;
  position: relative;
}

.Partners-Auto::before, .Partners-Auto::after {
  background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
  content: "";
  height: 300px;
  position: absolute;
  width: 150px;
  z-index: 2;
}

.Partners-Auto::before {
  left: -1px;
  top: 0;
}

.Partners-Auto::after {
  right: -1px;
  top: 0;
  transform: rotateZ(180deg);
}

.Partners-Auto .Partners-Container {
  display: inline-flex;
  flex-wrap: initial;
  animation: slide 40s linear infinite;
  width: calc(190px * var(--nbr2)); /* 125 width + 45 margin right + 20 margin left * (nombre élément * 2) */
}

.Partners-Auto .Partners-Container .Partners-Circle {
  display: inline-flex;
}

.Partners-Circle-bigger {
  width: 135% !important;
}

@keyframes slide {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-190px * var(--nbr)))
  }
}

/* 
* Circle
*/
.Partners-Circle, .Partners-Arrow-Circle {
  background: #FFFFFF;
  box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.2);
  border-radius: 100%;
  width: 125px;
  height: 125px;
  padding: 20px;
  box-sizing: border-box;
  margin: 20px 45px 0 20px;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.Partners-Arrow-Circle {
  width: 40px;
  height: 40px;
  border: solid 1px rgba(0, 0, 0, 0.2);
}

.Circle-Active {
  border: solid 1px rgba(0, 0, 0, 0.5);
  background-color: transparent;
  box-shadow: none;
}

.Partners-Circle img, .Partners-Arrow-Circle img {
  width: 100%;
  position: relative;
  margin: auto;
  display: block;
}

.Partners-Arrow-Circle img {
  width: 15px;
  opacity: 0.5;
}

/* 
* Responsive 
*/
@media (max-width: 700px) {
  .Partners-Auto::before, .Partners-Auto::after {
    width: 50px;
  }
}
</style>